import { AntDesignOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Tooltip } from "antd";
import React from "react";
import img1 from "../../assets/img/Invest1.jpeg";
import img2 from "../../assets/img/Invest2.jpeg";
import user3 from "../../assets/img/user/user1.png";
import user2 from "../../assets/img/user/user2.png";
import user4 from "../../assets/img/user/user3.png";
import user1 from "../../assets/img/user/user5.png";

export default function InvestDashboard() {
  const cards = [
    {
      title: "Start your Real Estate Journey",
      desc: "Learn our low risk buy & hold real estate investing strategy. Passively & safely build your portfolio.",
      btn: "Low",
      img: img1,
    },
    {
      title: "Start your Business Acquisition Journey",
      desc: "Learn our low risk buy & hold real estate investing strategy. Passively & safely build your portfolio.",
      btn: "Moderate",
      img: img2,
    },
  ];
  return (
    <div className="container mt-4">
      <div className="row">
        {cards.map((cards, index) => (
          <div className="col-lg-6 col-md-6 col-sm-6" key={index}>
            <div className="card p-0 bg-transparent">
              <img
                src={cards.img}
                alt=""
                style={{
                  borderRadius: "20px",
                  height: "350px",
                  objectFit: "cover",
                }}
              />
              <div className="d-flex align-items-center gap-3 justify-content-between mt-4">
                <h3 className="mb-0">{cards.title}</h3>
                <button className="btn">{cards.btn}</button>
              </div>
              <p className="mt-3">{cards.desc}</p>
            </div>
          </div>
        ))}
        <div className="c0l-lg-12">
          <div className="invest_dashboard_avatar_list mt-3">
            <Avatar.Group
              size="large"
              max={{
                count: 3,
                style: {
                  color: "#f56a00",
                  backgroundColor: "#fde3cf",
                  cursor: "pointer",
                },
                popover: {
                  trigger: "click",
                },
              }}
            >
              <Avatar src={user1} />
              <Avatar src={user2} />
              <Avatar src={user3} />
              <Avatar src={user4} />
              <Tooltip title="Ant User" placement="top">
                <Avatar src={user1} />
                <Avatar
                  style={{
                    backgroundColor: "#87d068",
                  }}
                  icon={<UserOutlined />}
                />
              </Tooltip>
              <Avatar
                style={{
                  backgroundColor: "#1677ff",
                }}
                icon={<AntDesignOutlined />}
              />
            </Avatar.Group>
            <div>
              <h3>Join our Community+</h3>
              <p className="mt-3" style={{ color: "#4caf50" }}>
                Combine your income with other investors in our community &
                collab on Investments together.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
